import {
	OrderNeedPay,
	OrderNeedAssess,
	OrderPayed,
	OrderHasReceived,
	OrderNeedSend,
	OrderNeedTake,
	OrderNeedCatch,
	OrderIsSending,
	OrderHasArrivals,
	OrderHasComment,
	OrderCancel,
	OrderReject,
	OrderRefunding,
	OrderRefundSuccess,
	OrderRefundError,
} from "@/constants/orderStatus";


export const OrderStatusTextMap = {
	OrderNeedPay,
	OrderNeedAssess,
	[OrderPayed]:'订单支付成功，请等待配送',
	OrderHasReceived,
	OrderNeedSend,
	OrderNeedTake,
	OrderNeedCatch,
	[OrderIsSending]:"骑手正在送餐，请保持电话畅通",
	[OrderHasArrivals]:'已完成',
	OrderHasComment,
	OrderCancel,
	OrderReject,
	OrderRefunding,
	OrderRefundSuccess,
	OrderRefundError,
}